import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Social action clicks tooltip - shows click count and percentage
 * @param {Object} props
 * @param {string} props.label - Brand name
 * @param {number} props.value - Click count
 * @param {number} props.percentage - Percentage of total
 * @returns {import("react").ReactElement}
 */
export default function SocialClicksTooltip(props) {
  const { label, value, percentage } = props;

  return (
    <Box sx={{ p: 0.5 }}>
      <Typography sx={{ fontWeight: 600 }}>{label}</Typography>
      <Typography>
        {value?.toLocaleString()} clicks ({percentage}%)
      </Typography>
    </Box>
  );
}
